import React, { Fragment } from 'react';

const SortCaretUp = () => (<span className="sort-caret-reverse" />);
const SortCaretDown = () => (<span className="sort-caret" />);
const HiddenSortCaret = () => (<span className="sort-caret-transparent" />);

// shows an up or down caret, or hides the caret, based on sort order
const DynamicCaret = ({ caretUp, caretDown, currentSortOrder }) => (
    currentSortOrder === caretUp
        ? <SortCaretUp />
        : currentSortOrder === caretDown
            ? <SortCaretDown />
            : <HiddenSortCaret />
);

// shows an up or down caret, or hides the caret, based on sort order with a default
const DynamicCaretWithDefault = ({
    caretUp, defaultUp, caretDown, defaultDown, currentSortOrder,
}) => (
    currentSortOrder === caretUp || currentSortOrder === defaultUp
        ? <SortCaretUp />
        : currentSortOrder === caretDown || currentSortOrder === defaultDown
            ? <SortCaretDown />
            : <HiddenSortCaret />
);

export { DynamicCaret, DynamicCaretWithDefault };
